import React from "react";
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';

import LinkButton from '../../components/linkButton';

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  card: {
      //minHeight: 165,
  },
  tabBar: {
    boxShadow: 'none',
    paddingTop: 8,
  },
  icon: {
    margin: theme.spacing.unit,
    fontSize: 48,
  },
  avatar: {
    backgroundColor: red[500],
  },
  newAvatar: {
    backgroundColor: green[500],
  },
});

class StaffList extends React.Component {
  constructor(props) {
    super(props);
    this.props=props;
    this.setState({activestafflist:[]});
    this.state.activestafflist=[];

  }


  componentDidMount(){
    this._isMounted = true;
    this.props.socket.emit("get_active_staff",{active:true,authenticator:this.props.authenticator});
    
    this.props.socket.on("active_staff_result",(d)=>{
        
        if(this._isMounted){
            
            this.activestafflist = d;
            this.setState({activestafflist:d});
            
        }
    });
  }

  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  randomColor = e=>{
    return '#'+Math.floor(Math.random()*16777215).toString(16);
  }

  render() {
      
    const { classes } = this.props;
    //console.log(this.state);
    return (
    <div className={classes.root}>
      <Grid container style={{ padding: 2 }} spacing={1}>
      {this.state.activestafflist.map(k=>
        <Grid item sm={12} md={3}>
            
                <Card className={classes.card}>
                    <CardHeader
                    
                    avatar={
                        
                        <Avatar aria-label={k.initials} className={classes.avatar}>
                        {k.initials}
                        </Avatar>
                    }
                    title={k.displayname}
                    subheader={k.jobrole}
                    />
                    <CardActions>
                    <LinkButton to={"/admin/staffedit/"+k.staff_id} text={"Edit "+k.displayname} />
                    
                    </CardActions>
                </Card>
            
        </Grid>
        )}
        <Grid item sm={12} md={3}>
            <Card className={classes.card}>
                <CardHeader
                avatar={
                    <Avatar aria-label="New Staff" className={classes.newAvatar}>
                    +
                    </Avatar>
                }
                title="New Staff"
                subheader="Add new user"
                />
                <CardActions>
                  <LinkButton to="/admin/staffedit" text="Add New Staff" />
                </CardActions>
            </Card>
          </Grid>
      </Grid>
    </div>
    );
  }
}

export default withStyles(styles)(StaffList);